import React from 'react';
import { Backdrop, DialogActions, DialogContent, DialogTitle, Paper, Portal } from '@mui/material';

import { useActiveBlurb } from '../context';
import { NextBlurbButton } from './BlurbPopper';
import { backdropSx } from './styles';

export function UnAnchoredBlurbRenderer() {
  const activeBlurb = useActiveBlurb();

  if (activeBlurb == null || activeBlurb.anchor) return null;

  return (
    <Portal>
      <Backdrop open sx={backdropSx}>
        <Paper>
          <DialogTitle>{activeBlurb.title}</DialogTitle>
          <DialogContent>{activeBlurb.renderContent()}</DialogContent>

          <DialogActions>
            <NextBlurbButton />
          </DialogActions>
        </Paper>
      </Backdrop>
    </Portal>
  );
}
